import request from '@/axios/index.js'
const uri = '/dic/getDic/';

export function getDic(data) {
    return request.axios({
        url: uri,
        data:data,
        type:"get",
        noEncryptParam:true
    })
}
// 获取省市区
export function getAreaList(data) {
    return request.axios({
        url: "/dic/getAreaList",
        data:data,
        type:"post"
    })
}



// WEBPACK FOOTER //
// ./src/api/dic.js